<template>
    <div>

        <div class="picked-users">
            <div>
                <div v-for="person in pickedPeople" class="form-check">
                    <input
                        type="checkbox"
                        checked="checked"
                        class="form-check-input"
                        v-bind:value="person.id"
                        v-on:click="removePerson($event, person)"
                        v-bind:id="'checkbox-ac-' + person.id"
                        v-bind:name="'users['+person.id+']'">
                    <label class="form-check-label" v-bind:for="'checkbox-ac-' + person.id">{{ person.full_name }} ({{ person.company_name }})</label>
                </div>
            </div>
        </div>


        <div class="search-form-mask open">
            <input type="text" class="search-input" v-model="searchText" placeholder="User name or company name">
            <input class="search-input__button"  />
            <button class="btn btn-light sb-icon-search"  v-on:click="searchPeople($event)">
                <span class="fa fa-search">
                    <span class="visually-hidden">Search</span>
                </span>
            </button>
        </div>



        <div class="chosen-people-wrapper">
            <div v-for="person in people" class="form-check">
                <input type="checkbox" class="form-check-input"  v-bind:value="person.id" v-on:click="addPerson($event, person)"  v-bind:id="'person' + person.id">
                <label class="form-check-label" v-bind:for="'person' + person.id">{{ person.full_name }} ({{ person.company_name }})</label>
            </div>
        </div>
    </div>
</template>

<script>

import Users from "../Services/Users";

export default {
        name: "UserSearchComponent",
        props: ['centreId', 'existingUsers'],
        data: function () {
            return {
                people: [],
                pickedPeople: [],
                searchText: ''
            }
        },
        mounted: function () {
          this.hydrateExistingUsers();
        },
        methods: {

            searchPeople: function (event) {

                event.preventDefault();

                Users.searchByNameOrCompanyName(this.searchText, this.centreId).then((users) => {
                    users = users.map((user) => {
                        if(user.companies.length > 0) {
                            user.company_name = user.companies[0].name;
                        }

                        return user;
                    });
                    this.people = users;
                })
            },

            removePerson: function (event, person) {
                event.preventDefault();

                this.pickedPeople = this.pickedPeople.filter((pickedPerson) => {
                    return pickedPerson.id !== person.id;
                });

                this.people.push(person);
            },

            addPerson: function (event, pickedPerson) {

                event.preventDefault();

                this.pickedPeople.push(pickedPerson);

                this.people = this.people.filter((person) => {
                    return person.id !== pickedPerson.id;
                });
            },

            hydrateExistingUsers: function () {

                let users = this.existingUsers.map((user) => {
                    if(user.companies.length > 0) {
                        user.company_name = user.companies[0].name;
                    }

                    this.addPerson(new MouseEvent('click'), user);
                });


            }
        }
    }
</script>

<style scoped>
    .form-check {
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .search-input {
        position: absolute;
        top: 0;
        right: 0;
        outline: none;
        height: 30px;
        margin: 0;
        z-index: 10;

        font-family: inherit;
        border-radius: 22px;
        color: #babfbf;
        box-shadow: none;
        border: 1px solid #979ca2;
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.6;
        width: 100%;
    }

    .search-input__button {
        background: #fff;
        filter: alpha(opacity=0);
        opacity: 0;
        color: transparent;
        border: none;
        outline: none;
        width: 25px;
    }
</style>
